bridge-modal {
  .modal-basic {
    margin-top: var(--spacing-md);
    margin-left: var(--spacing-md);
  }
}
